// src/components/common/ChipFilter.tsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import { categories } from '../../data/categories';
import Icon from './Icon';

/** 히어로 아래 가로 아이콘 필터 */
const ChipFilter: React.FC = () => (
    <nav className="gh-chips" aria-label="지원금 분야 바로가기">
        {categories.map(c => (
            <NavLink
                key={c.id}
                to={c.path}
                end={c.path === '/'}
                className={({ isActive }) => `gh-chip${isActive ? ' is-active' : ''}`}
            >
                <span className="gh-chip__icon">
                    <Icon name={c.icon} size={20} />
                </span>
                {c.shortName}
            </NavLink>
        ))}
    </nav>
);

export default ChipFilter;
